import React, { useMemo } from 'react';
import { T } from '@colonist/ui';
import { ActionCell } from './ActionCell/ActionCell.tsx';
import styles from './FriendsTableColumns.module.scss';
export const useFriendsTableColumns = ({ onGiftClick })=>useMemo(()=>[
            {
                id: 'username',
                overflow: 'truncate',
                className: styles.usernameColumn,
                header: ()=>/*#__PURE__*/ React.createElement(T, {
                        id: {
                            key: 'strings:profilePage.friends.tableHeaders.player'
                        }
                    })
            },
            {
                id: 'statusText',
                overflow: 'nowrap',
                className: styles.statusColumn,
                header: ()=>/*#__PURE__*/ React.createElement(T, {
                        id: {
                            key: 'strings:profilePage.friends.tableHeaders.status'
                        }
                    }),
                cell: ({ value: statusText })=>/*#__PURE__*/ React.createElement(T, {
                        id: statusText
                    })
            },
            {
                id: 'activityText',
                overflow: 'truncate',
                className: styles.activityColumn,
                header: ()=>/*#__PURE__*/ React.createElement(T, {
                        id: {
                            key: 'strings:profilePage.friends.tableHeaders.activity'
                        }
                    }),
                cell: ({ value: activityText })=>/*#__PURE__*/ React.createElement(T, {
                        id: activityText
                    })
            },
            {
                id: 'showGift',
                overflow: 'nowrap',
                align: 'right',
                className: styles.actionColumn,
                header: '',
                cell: ({ value: showGift, row })=>{
                    if (showGift != true) return null;
                    return /*#__PURE__*/ React.createElement(ActionCell, {
                        userId: row.userId,
                        username: row.username,
                        onGiftClick: onGiftClick
                    });
                }
            }
        ], [
        onGiftClick
    ]);
